import React from 'react';
import './Footer.css';

interface FooterProps {
  onNavigate?: (path: string) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-copyright">
          © 2025 Mantisflow Inc. All rights reserved.
        </p>
        <p className="footer-contact">
          For any questions, contact <a href="mailto:selen@itsremi.ai">selen@itsremi.ai</a> or <a href="mailto:rupa@itsremi.ai">rupa@itsremi.ai</a>
        </p>
        <div className="footer-links">
          <a 
            href="/privacy-policy" 
            className="footer-link"
            onClick={(e) => {
              e.preventDefault();
              onNavigate?.('/privacy-policy');
            }}
          >
            Privacy Policy
          </a>
          <span className="footer-separator">•</span>
          <a 
            href="/terms-of-service" 
            className="footer-link"
            onClick={(e) => {
              e.preventDefault();
              onNavigate?.('/terms-of-service');
            }}
          >
            Terms of Service
          </a>
          <span className="footer-separator">•</span>
          <a 
            href="/security" 
            className="footer-link"
            onClick={(e) => {
              e.preventDefault();
              onNavigate?.('/security');
            }}
          >
            Security
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;